import { SentryError } from '@ifixit/sentry';
import type { SearchClientType } from 'Guide/searchClient';

export const multiSearchAlgolia = async <T>(
   searchClient: SearchClientType,
   indexNames: string[],
   query: string,
   maxHits?: number
) => {
   if (!searchClient) {
      throw new SentryError('Algolia search client not set up');
   }
   // Use the v5 search API with multiple queries
   const { results } = await searchClient.search<T>({
      requests: indexNames.map(indexName => ({
         indexName,
         query,
         hitsPerPage: maxHits,
      })),
   });
   const combinedResults = results.flatMap(result => ('hits' in result ? result.hits : []));
   return maxHits ? combinedResults.slice(0, maxHits) : combinedResults;
};
